import Http from "../../http/client";

export default async ({userId}) => {
    const response = await Http.get(`admin/trip/driver/membership/${userId}/history`);

    return response.data;
}
